import { Box, styled } from '@mui/material'
import type { FC } from 'react'

import { COLORS } from '../../../constants'
import { isLibPropValid, unit } from '../../../utils'

export interface StepperProps {
  highlight: number
  of: number
}

export const Stepper: FC<StepperProps> = ({ highlight, of }) => {
  const steps = Array.from({ length: of }, (_, index) => <Step key={index} isActive={index <= highlight - 1} />)

  return <StepperContainer>{steps}</StepperContainer>
}

const StepperContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${unit(2)};
`

const Step = styled(Box, { shouldForwardProp: isLibPropValid })<{ readonly isActive: boolean }>`
  width: ${unit(6)};
  height: ${unit(1)};
  background-color: ${props => (props.isActive ? COLORS.semantic.floatingLabel : COLORS.hiekka[500])};
`
